import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Emoji } from "projects/pax-ui/components/emoji/emoji-alt-mapping";
import { delay, map } from "rxjs";
import { FormName } from "src/app/shared/models/form-name";
import { Gender } from "src/app/shared/store/quote/shared/shared.state";
import { BasePage, PremiumFormModel } from "../base/base.page";
import { CheckoutPage } from "../checkout-page/checkout-page";

@UntilDestroy()
@Component({
  selector: "app-gender",
  imports: [CommonModule, CheckoutPage],
  templateUrl: "../base/base.page.html",
  styleUrls: ["../base/base.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenderPage extends BasePage implements OnInit {
  public override emojis: Emoji[] = ["🧑"];

  public override infoDialog = {
    buttonLabel: $localize`Warum ist das wichtig?`,
    title: $localize`Die Rolle des biologischen Geschlechts`,
    contentAsMarkdown: $localize`Versicherungen berücksichtigen das biologische Geschlecht, weil es statistisch relevante Unterschiede in Lebenserwartung und Risikoverhalten gibt. Das wirkt sich auf die Prämienhöhe aus.
Bitte geben Sie das Geschlecht an, das in Ihrem amtlichen Ausweis vermerkt ist. Aus regulatorischen Gründen können aktuell keine weiteren Geschlechtsidentitäten berücksichtigt werden.`,
  };

  public override formConfiguration = {
    name: FormName.GENDER,
    rows: [
      {
        items: [this.formComponentService.getGenderField()],
      },
    ],
  };

  public override onFormChange(premiumForm: PremiumFormModel | null) {
    if (!premiumForm) {
      return;
    }

    switch (premiumForm.gender) {
      case Gender.FEMALE:
        this.emojis = ["👩‍🦰"];
        break;
      case Gender.MALE:
        this.emojis = ["👨"];
        break;
      default:
        this.emojis = ["🧑"];
    }
  }

  ngOnInit() {
    super.initialize(this.formConfiguration);
    this.data$ = this.loadFormValuesFromStoreObservable();
  }

  private loadFormValuesFromStoreObservable() {
    return this.quoteStoreFacade
      .getGenderPageState(this.productSpecificCustomRouteData.product)
      .pipe(
        delay(0),
        untilDestroyed(this),
        map((genderPageState) => {
          const premiumForm: PremiumFormModel = {
            gender: genderPageState.gender,
          };
          return premiumForm;
        }),
      );
  }
}
